import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-643a4246"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-text" }, " Viglacera ", -1))
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = {
  class: "nav nav-pills nav-sidebar flex-column",
  "data-widget": "treeview",
  role: "menu",
  "data-accordion": "false"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-left right" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "nav nav-treeview"
}
const _hoisted_7 = {
  key: 0,
  class: "fas fa-angle-left right"
}
const _hoisted_8 = {
  key: 1,
  class: "nav nav-treeview"
}
const _hoisted_9 = {
  key: 0,
  class: "fas fa-angle-left right"
}
const _hoisted_10 = {
  key: 1,
  class: "nav nav-treeview"
}
const _hoisted_11 = {
  key: 0,
  class: "fas fa-angle-left right"
}

import { onMounted, ref, watch, reactive } from 'vue'
import JQuery from 'jquery'
import { ElTree } from 'element-plus'
import store from '@/store/index'
import { useRouter } from 'vue-router'
import { useCookies } from "vue3-cookies"
import SubMenu from '@/store/common/index'

interface Tree {
    id: number,
    label: string,
    url: string,
    icon: string,
    role: string,
    children?: Tree[],
    isExpandChilds: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

const filterText = ref('')
const treeRef = ref<InstanceType<typeof ElTree>>()

const defaultProps = {
    children: 'children',
    label: 'label',
    url: 'url',
    icon: 'icon'
}

const { cookies } = useCookies();
const router = useRouter()
const logOut = () => {
    store.dispatch('setLoggedIn', false)
    cookies.remove('user')
    localStorage.removeItem('user')
    router.push({ path: './' })
}

const filterNode = (value: string, data: Tree) => {
    if (!value) return true
    return data.label.includes(value)
}

const data: Tree[] = [
    {
        id: 800,
        label: 'Tổng quan',
        url: 'dashboard',
        icon: 'nav-icon fa-solid fa-gauge',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    },
    // {
    //     id: 805,
    //     label: 'Báo cáo',
    //     url: 'report',
    //     icon: 'nav-icon fa-solid fa-signal',
    //     isExpandChilds: false,
    //     role: 'admin',
    //     children: [],
    // },
    {
        id: 801,
        label: 'Tạo quay thưởng',
        url: 'promotion',
        icon: 'nav-icon fa-solid fa-gift',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    },
    {
        id: 802,
        label: 'Duyệt tích điểm',
        url: 'point',
        icon: 'nav-icon fa-solid fa-database',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    }, {
        id: 802,
        label: 'Duyệt đổi quà',
        url: 'gift-register',
        icon: 'nav-icon fa-solid fa-gift',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    },

    {
        id: 802,
        label: 'Quà đổi',
        url: 'gifts',
        icon: 'nav-icon fa-solid fa-gift',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    },
    {
        id: 8031,
        label: 'Nhà thầu',
        url: 'userlist',
        icon: 'nav-icon fa-solid fa-id-badge',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    },
    {
        id: 804,
        label: 'Sản phẩm',
        url: 'admin-products',
        icon: 'nav-icon fa-brands fa-product-hunt',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    },
    // {
    //     id: 8041,
    //     label: 'Học viện',
    //     url: 'academys',
    //     icon: 'nav-icon fa-solid fa-graduation-cap',
    //     isExpandChilds: false,
    //     role: 'admin',
    //     children: [],
    // },
    {
        id: 10031,
        label: 'Tin tức & Sự kiện',
        url: 'admin-news',
        icon: 'nav-icon fa-solid fa-circle-info',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    },

    {
        id: 1003,
        label: 'Feedback',
        url: 'feedback',
        icon: 'nav-icon fa-solid fa-circle-info',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    },
    {
        id: 1003,
        label: 'Hướng dẫn',
        url: 'blog',
        icon: 'nav-icon fa-solid fa-circle-info',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    },
    {
        id: 10031,
        label: 'Lịch sử đổi quà',
        url: 'his-gift',
        icon: 'nav-icon fa-solid fa-clock-rotate-left',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    }
    , {
        id: 1001,
        label: 'Lịch sử quay thưởng',
        url: 'his-wheel',
        icon: 'nav-icon fa-solid fa-clock-rotate-left',
        isExpandChilds: false,
        role: 'admin',
        children: []
    },
    {
        id: 1002,
        label: 'Lịch sử tham gia',
        url: 'his-register',
        icon: 'nav-icon fa-solid fa-clock-rotate-left',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    },
    {
        id: 1003,
        label: 'Lịch sử tích điểm',
        url: 'his-point',
        icon: 'nav-icon fa-solid fa-clock-rotate-left',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    },
    {
        id: 806,
        label: 'Tài khoản',
        url: 'informAdmin',
        icon: 'nav-icon fa-solid fa-user',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    },
    {
        id: 10031,
        label: 'Gửi tin zalo',
        url: 'zalo-log',
        icon: 'nav-icon fa-solid fa-circle-info',
        isExpandChilds: false,
        role: 'admin',
        children: [],
    }
]
const state = reactive({
    treeData: data
});
const isMenuExtended = ref(false);
const isExpandable = ref(false);
const isExpandableChild = ref(false);
const toggleMenu = () => {
    isMenuExtended.value = !isMenuExtended.value;
};

const handleMainMenuAction = () => {
    if (isExpandable) {
        toggleMenu();
        return;
    }
};
const handleMainMenuChildAction = () => {
    isExpandableChild.value = !isExpandableChild.value;
};

// onMounted(() => {
//     let $ = JQuery
//     $(document).on('click', '.sidebar .link-tab', function (e) {
//         let element = $(this).parent('li').html();
//         $('.nav-top li:first-child').after('<li class="nav-item parent-add-nav">' + element + '</li>');
//     })
// })


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(`main-sidebar elevation-4 ${_ctx.$store.getters.sidebarSkin}`)
  }, [
    _createVNode(_component_router_link, {
      to: "./",
      class: "brand-link elevation-3"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.treeData, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["nav-item", { 'menu-is-opening menu-open': item.isExpandChilds }]),
              key: index
            }, [
              (item.children?.length > 0)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(item.icon)
                      }, null, 2),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(item.label) + " ", 1),
                        _hoisted_5
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (item.children?.length || 0 > 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (childLv1, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(["nav-item", { 'menu-is-opening menu-open': childLv1.isExpandChilds }]),
                        key: index
                      }, [
                        (childLv1.children?.length || 0 > 0)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: "",
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("i", {
                                  class: _normalizeClass(childLv1.icon)
                                }, null, 2),
                                _createElementVNode("p", null, [
                                  _createTextVNode(_toDisplayString(childLv1.label) + " ", 1),
                                  (childLv1.children?.length || 0 > 0)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (childLv1.children?.length || 0 > 0)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childLv1.children, (childLv2, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: _normalizeClass(["nav-item", { 'menu-is-opening menu-open': childLv2.isExpandChilds }]),
                                  key: index
                                }, [
                                  (childLv2.children?.length || 0 > 0)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        to: "",
                                        class: "nav-link"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("i", {
                                            class: _normalizeClass(childLv2.icon)
                                          }, null, 2),
                                          _createElementVNode("p", null, [
                                            _createTextVNode(_toDisplayString(childLv2.label) + " ", 1),
                                            (childLv2.children?.length || 0 > 0)
                                              ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  (childLv2.children?.length || 0 > 0)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childLv2.children, (childLv3, index) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            class: _normalizeClass(["nav-item", { 'menu-is-opening menu-open': childLv2.isExpandChilds }]),
                                            key: index
                                          }, [
                                            (childLv3.children?.length || 0 > 0)
                                              ? (_openBlock(), _createBlock(_component_router_link, {
                                                  key: 0,
                                                  to: "",
                                                  class: "nav-link"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("i", {
                                                      class: _normalizeClass(childLv3.icon)
                                                    }, null, 2),
                                                    _createElementVNode("p", null, [
                                                      _createTextVNode(_toDisplayString(childLv3.label) + " ", 1),
                                                      (childLv3.children?.length || 0 > 0)
                                                        ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : (_openBlock(), _createBlock(_component_router_link, {
                                                  key: 1,
                                                  to: childLv3.url,
                                                  class: "nav-link"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("i", {
                                                      class: _normalizeClass(childLv3.icon)
                                                    }, null, 2),
                                                    _createElementVNode("p", null, _toDisplayString(childLv3.label), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to"]))
                                          ], 2))
                                        }), 128))
                                      ]))
                                    : (_openBlock(), _createBlock(_component_router_link, {
                                        key: 2,
                                        to: childLv2.url,
                                        class: "nav-link"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("i", {
                                            class: _normalizeClass(childLv2.icon)
                                          }, null, 2),
                                          _createElementVNode("p", null, _toDisplayString(childLv2.label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                ], 2))
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock(_component_router_link, {
                              key: 2,
                              to: childLv1.url,
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("i", {
                                  class: _normalizeClass(childLv1.icon)
                                }, null, 2),
                                _createElementVNode("p", null, _toDisplayString(childLv1.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                      ], 2))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    to: item.url,
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(item.icon)
                      }, null, 2),
                      _createElementVNode("p", null, _toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
            ], 2))
          }), 128))
        ])
      ])
    ])
  ], 2))
}
}

})